import React, {
  useState,
  useEffect,
} from "react";
import {
  Table,
  Button,
  Modal,
  Form,
} from "antd";
import {
  InfoCircleOutlined,
} from "@ant-design/icons";

import { formatDateTime } from "../../helpers/date";
import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";


const OrderEventList = ({
  orders,
  loading,
  selectedRows,
  onSelectRows,
}) => {
  const { permissions } = usePermissions();

  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [messageData, setMessageData] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    {
      title: "Change At",
      dataIndex: ["changeAt", "iso"],
      width: 180,
      ellipsis: true,
      fixed: isMobile ? undefined : "left",
      render: (text) => formatDateTime(text),
    },
    {
      title: "Change By",
      dataIndex: ["changeBy", "username"],
      width: 190,
      fixed: isMobile ? undefined : "left",
    },
    {
      title: "Change Source",
      dataIndex: "changeSource",
      width: 180,
      ellipsis: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: 180,
      ellipsis: true,
      render: (text) => formatDateTime(text),
    },
    {
      title: "Previous Amount",
      dataIndex: "previousAmount",
      width: 170,
      ellipsis: true,
    },
    {
      title: "New Amount",
      dataIndex: "newAmount",
      width: 130,
    },
    {
      title: "Previous Price",
      dataIndex: "prevPrices",
      align: "center",
      render: (text) =>
      (
        <Button
          icon={<InfoCircleOutlined />}
          shape="circle"
          size="small"
          type="primary"
          onClick={() => showMessage(text)}
        ></Button>
      ),
    },
    {
      title: "New Price",
      dataIndex: "newPrices",
      align: "center",
      render: (text) =>
      (
        <Button
          icon={<InfoCircleOutlined />}
          shape="circle"
          size="small"
          type="primary"
          onClick={() => showMessage(text)}
        ></Button>
      ),
    },
    {
      title: "Order",
      dataIndex: ["order", "objectId"],
    },
  ];

  const showMessage = (text) => {
    let courierResponse = JSON.stringify(text, null, 2);
    setMessageData(courierResponse);
    setIsMessageVisible(true);
  };

  return (
    <div className="table">
      <Table
        rowKey={(record) => record.objectId}
        rowSelection={{
          selectedRowKeys: selectedRows,
          onChange: onSelectRows,
        }}
        pagination={false}
        columns={columns}
        dataSource={orders}
        scroll={{ x: 1500, y: 600 }}
        loading={loading}
      />
      <Modal
        title="Message"
        visible={isMessageVisible}
        onOk={() => setIsMessageVisible(false)}
        onCancel={() => setIsMessageVisible(false)}
      >
        <pre>{messageData}</pre>
      </Modal>
    </div>
  );
};

export default OrderEventList;
